import { render, staticRenderFns } from "./famous.vue?vue&type=template&id=2d0433f0&"
import script from "./famous.vue?vue&type=script&lang=js&"
export * from "./famous.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports